var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"backButton pr-3",on:{"click":_vm.goBack}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"indigo_5"}},[_vm._v("fas fa-arrow-left")]),_c('span',{staticClass:"backButton__text"},[_vm._v("Назад")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }